import React, { Component } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { Container, Avatar, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Table, TableContainer, Button, TableHead, TableRow, TableBody, TableCell,IconButton} from '@material-ui/core';
import firestore from 'firebase';
import { consumerFirebase } from '../../config';
import Print from './Print';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  cardGrid: {
    paddingLeft: "5em"

 },
 homeIcon: {
    width: 20,
    height: 20,
    marginRight: "4px"
 },
 link: {
    display: "flex",
 },
 gridTextField: {
    marginTop: "2em"
 },
 card: {
    height: "100%",
    display: "flex",
    flexDirection:"column"
 },
 cardMedia: {
    paddingTop: "56.25%"
 },
 cardContent: {
    flexGrow: 1
 },
 tablecontainer: {
    margin: "auto"
 },
 paper: {
    marginTop: "2em",
    paddingTop: "1em",
    paddingBottom: "2em",
    alignContent: "center",
    width: "100%"
 },
 avatarRestaurant: {
    width: 100,
    height: 100,
    paddingLeft: '6%',
 }
});

// Create Document Component
class DocumentPDF extends Component {
    state = {
        users: [],
        redirect: false,
        show: false
    }

    async componentDidMount(){
        let objectQuery = this.props.firebase.db.collection("Usuarios").orderBy("name");
  
        const snapshot = await objectQuery.get();
  
        const arrayProduct = snapshot.docs.map(doc => {
           let data = doc.data();
           let id = doc.id;
           return { id, ...data};
        })
  
        this.setState({
           users: arrayProduct,
           show: true
        })
    }
  
    render(){
        return (
                <div id={this.props.printableId}>
                    <br></br>
                    <table style={{borderCollapse: "collapse", width: '90%'}}>
                        <tr style={{textAlign:'center', marginBottom:'3em'}}>
                            <th>Nombre Completo</th>
                            <th>Email</th>
                            <th>Sexo</th>
                            <th>Edad</th>
                            <th>Ciudad</th>
                        </tr>
                        <br></br>
                        {this.state.users.map(info => (                
                        <tr style={{
                            textAlign:'center', 
                            border: "1px solid #ddd",
                            height:"3em"
                        }}>
                            <td>{info.name + ' ' + info.fullname}</td>
                            <td>{info.email}</td>
                            <td>{info.sex}</td>
                            <td>{info.age}</td>
                            <td>{info.city}</td>
                        </tr>
                        ))}
                    </table>            
                </div>
          );
    }
};

export default consumerFirebase(DocumentPDF);